import { ClickAwayListener, MenuList, Paper, Popper } from '@material-ui/core';
import { FC, KeyboardEvent, MouseEvent, useRef, useState } from 'react';
import {
  StyledButton,
  IconWrapper,
  StyledMenuItem,
} from 'components/ActionDropDown/style';
import ArrowDownGrayIcon from 'components/SahamIcons/ArrowDownGrayIcon';

interface Item {
  title: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export interface ActionDropDownProps {
  label: string;
  items: Item[];
}

const ActionDropDown: FC<ActionDropDownProps> = props => {
  const { label, items } = props;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleToggle = (e: MouseEvent<EventTarget>) => {
    e.stopPropagation();
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = (event: MouseEvent<EventTarget>) => {
    setOpen(false);
  };

  function handleListKeyDown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  return (
    <div>
      <StyledButton ref={anchorRef} onClick={handleToggle}>
        {label}
        <IconWrapper>
          <ArrowDownGrayIcon />
        </IconWrapper>
      </StyledButton>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined}>
        <Paper>
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList
              autoFocusItem={open}
              id="menu-list-grow"
              onKeyDown={handleListKeyDown}
            >
              {items.map(({ title, onClick }) => (
                <StyledMenuItem
                  onClick={e => {
                    e.stopPropagation();
                    onClick(e);
                    handleClose(e);
                  }}
                >
                  {title}
                </StyledMenuItem>
              ))}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popper>
    </div>
  );
};

export default ActionDropDown;
